import React, { useEffect, useState } from "react";
import { Maximize2 } from "lucide-react";
import axios from "axios";
import heartLoading from "../../../assests/heartLoading.gif";
import KpiLineage from "../Domain/KpiLineage";

/**
 * Combines all product assets, KPIs, and columns into a single lineage graph.
 * Uses the same KpiLineage component, but merges all assets into one graph.
 */
export default function ProductKpiLineage({ productName }) {
  const [loading, setLoading] = useState(true);
  const [lineageData, setLineageData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!productName) return;
    setLoading(true);
    setError(null);
    axios
      .get(`${process.env.REACT_APP_API_URL}/kpi-product`, {
        params: { product_name: productName },
      })
      .then((res) => {
        if (res.data && Array.isArray(res.data.assets)) {
          setLineageData(res.data);
        } else {
          setLineageData(null);
        }
        setLoading(false);
      })
      .catch((err) => {
        setError("Failed to load KPI lineage");
        setLoading(false);
      });
  }, [productName]);

  const getFullScreenUrl = () => {
    if (!productName) return "";
    const params = new URLSearchParams();
    params.set("mode", "product");
    params.set("productName", productName);
    return `/kpi-lineage-fullscreen?${params.toString()}`;
  };

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center" style={{ height: "60vh" }}>
        <img src={heartLoading} alt="Loading..."style={{ width : 200}} />
        <span className="text-gray-700 text-[20px] mt-3">Loading KPI lineage...</span>
      </div>
    );
  }
  if (error) {
    return <div className="text-red-500 text-center py-8">{error}</div>;
  }
  if (!lineageData) {
    return <div className="text-gray-500 text-center py-8">No KPI lineage data available.</div>;
  }
  // Use KpiLineage but pass custom nodes/edges
  return (
    <div className="flex flex-col h-full" style={{ width: "100%", position: "relative" }}>
      {productName && (
        <div className="flex items-center gap-2 shrink-0 border-b border-slate-200 px-2 py-2">
          <a
            href={getFullScreenUrl()}
            target="_self"
            title="View in full screen"
            aria-label="View in full screen"
            className="inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold whitespace-nowrap border border-blue-200 bg-blue-50 text-blue-700 shadow-sm transition-colors hover:border-blue-300 hover:bg-blue-100"
          >
            <Maximize2 className="h-4 w-4" />
            <span>Full screen</span>
          </a>
        </div>
      )}
      <div style={{ width: "100%", height: "80vh", minHeight: "30vh", position: "relative", flex: 1 }}>
        <KpiLineage data={lineageData} loading={false} />
      </div>
    </div>
  );
}
